import * as Html from "../../util/Html.ts";

function toggle(this: HTMLElement): void {
  const node = this;

  node.classList.toggle('fw-background-branded');

  const input = node.querySelector('input');
  if (input) {
    input.disabled = !node.classList.contains('fw-background-branded');
  }
}

function initDom(node: HTMLElement): void {
  node.style.cursor = 'pointer';

  const input = node.querySelector('input');
  if (input) {
    input.disabled = !node.classList.contains('fw-background-branded');
  }

  node.addEventListener('click', toggle);
}

Html.registerWidget('widget/specific/mprecipecat',{initDom})
